export const ONBOARDING = "ONBOARDING";
export const ONBOARDING_SUCCESS = "ONBOARDING_SUCCESS";
export const ONBOARDING_API_ERROR = "ONBOARDING_API_ERROR";
